import { Component, Input, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../pipes/translate.pipe';
import { TranslationService } from '../services/translation.service';
import { RouteInstructionVm } from './routing.models';
import { InstructionType } from '@navvis/ivion';
import { inject } from '@angular/core';

@Component({
  selector: 'app-route-instruction',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  template: `
    <div class="clickable route-instruction-container" (click)="moveToInstruction()">
      <img width="24" [src]="iconUrl" />
      <div>
        <div class="item" [class.bolded]="showDescription">{{ name }}</div>
        <div *ngIf="showDescription">
          <span>{{ 'navigation_instruction_building' | translate }}</span>: {{ instruction.buildingName }}
          | <span>{{ 'navigation_instruction_floor' | translate }}</span>: {{ instruction.floor }}
        </div>
      </div>
    </div>
  `,
  styles: []
})
export class RouteInstructionComponent implements OnChanges {
  @Input() instruction!: RouteInstructionVm;

  private translationService = inject(TranslationService);
  private readonly prefix = 'route_instruction_';

  name = '';
  iconUrl = '';
  showDescription = false;

  ngOnChanges(): void {
    if (!this.instruction) return;
    this.showDescription =
      this.instruction.type === InstructionType.START ||
      this.instruction.type === InstructionType.END;
    this.name = this.getInstructionName();
    this.iconUrl = `assets/images/routing/${this.instruction.type}.png`;
  }

  moveToInstruction(): void {
    this.instruction.originalInstruction.moveToInstruction().catch(() => {});
  }

  private getInstructionName(): string {
    const translated = this.translationService.translate(`${this.prefix}${this.instruction.type}`);

    if (this.instruction.type.indexOf('walk') !== -1) {
      return `${translated} ${this.instruction.buildingName || ''}`.trim();
    }
    if (this.instruction.type.indexOf('floor') !== -1) {
      return `${translated} ${this.instruction.floor || ''}`.trim();
    }
    if (
      this.instruction.type.indexOf('elevator') !== -1 ||
      this.instruction.type.indexOf('stairs') !== -1
    ) {
      const toFloor = this.translationService.translate(`${this.prefix}to_floor`);
      return `${translated} ${toFloor} ${this.instruction.floor || ''}`.trim();
    }

    return translated;
  }
}
